// extracted by mini-css-extract-plugin
module.exports = {"root":"IconChevronRight_root__3RqVt"};